export const structureError = (error) => {
  if (error.response) {
    return error.response.data.msg;
  } else {
    return error.message;
  }
};
